import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'ml.quoteandbind.addllocationscheditem.address',
        defaultMessage: 'Address'
    },
    numFamilies: {
        id: 'ml.quoteandbind.addllocationscheditem.numFamilies',
        defaultMessage: 'Number of Families'
    },
    propertyType: {
        id: 'ml.quoteandbind.addllocationscheditem.propertyType',
        defaultMessage: 'Type of Property'
    },
    description: {
        id: 'ml.quoteandbind.addllocationscheditem.description',
        defaultMessage: 'Description'
    },
    action: {
        id: 'ml.quoteandbind.addllocationscheditem.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.addllocationscheditem.modalTitle',
        defaultMessage: 'Add Additional Location Not Rented'
    },
    addressLine1: {
        id: 'ml.quoteandbind.addllocationscheditem.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.addllocationscheditem.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.addllocationscheditem.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.addllocationscheditem.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.addllocationscheditem.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.addllocationscheditem.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.addllocationscheditem.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.addllocationscheditem.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.addllocationscheditem.continueBtn',
        defaultMessage: 'Continue'
    },
});
